// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__bW-QE","boxTitle":"Qualiphy_boxTitle__2iTB3","box":"Qualiphy_box__20WVL","toggleWrap":"Qualiphy_toggleWrap__2g0Ge"};